'use client';

import { c as _c } from "react/compiler-runtime";
import 'rc-slider/assets/index.css';
import { useLocale } from 'next-intl';
import { type SliderProps } from 'rc-slider';
import Slider from 'rc-slider';
import { type ChangeEvent, useEffect, useState } from 'react';
import { getLangDir } from 'rtl-detect';
import styles from './input-range-slider.module.scss';
interface InputRangeProps extends Omit<SliderProps, 'onChange' | 'value'> {
  value: [number, number];
  onChange: (min: string, max: string) => void;
  min: number;
  max: number;
  ariaLabelMin: string;
  ariaLabelMax: string;
}
export default function InputRange(propsSlider) {
  const $ = _c(50);
  const {
    ariaLabelMax,
    ariaLabelMin,
    disabled,
    max,
    min,
    onChange,
    step,
    value
  } = propsSlider;
  const locale = useLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = getLangDir(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const direction = t0;
  const [minValue, setMinValue] = useState(value[0]);
  const [maxValue, setMaxValue] = useState(value[1]);
  const [minInputValue, setMinInputValue] = useState(value[0]);
  const [maxInputValue, setMaxInputValue] = useState(value[1]);
  let t1;
  if ($[2] !== value[0] || $[3] !== value[1]) {
    t1 = () => {
      setMinValue(value[0]);
      setMinInputValue(value[0]);
      setMaxValue(value[1]);
      setMaxInputValue(value[1]);
    };
    $[2] = value[0];
    $[3] = value[1];
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== value) {
    t2 = [value];
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  const isMinValueNull = minInputValue === 0;
  const isMaxValueNull = maxInputValue === 0;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event => {
      const inputMinValue = Number(event.target.value);
      setMinInputValue(inputMinValue);
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleLowerBoundChange = t3;
  let t4;
  if ($[8] !== maxInputValue || $[9] !== min || $[10] !== onChange) {
    t4 = event_0 => {
      let inputMinValue_0 = Number(event_0.target.value);
      if (inputMinValue_0 > maxInputValue) {
        inputMinValue_0 = maxInputValue;
      }
      if (inputMinValue_0 < min) {
        inputMinValue_0 = min;
      }
      onChange(String(inputMinValue_0), String(maxInputValue));
      setMinValue(inputMinValue_0);
      setMinInputValue(inputMinValue_0);
    };
    $[8] = maxInputValue;
    $[9] = min;
    $[10] = onChange;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleLowerBoundValue = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event_1 => {
      const inputMaxValue = Number(event_1.target.value);
      setMaxInputValue(inputMaxValue);
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleUpperBoundChange = t5;
  let t6;
  if ($[13] !== max || $[14] !== minInputValue || $[15] !== onChange) {
    t6 = event_2 => {
      let inputMaxValue_0 = Number(event_2.target.value);
      if (inputMaxValue_0 < minInputValue) {
        inputMaxValue_0 = minInputValue;
      }
      if (inputMaxValue_0 >= max) {
        inputMaxValue_0 = max;
      }
      onChange(String(minInputValue), String(inputMaxValue_0));
      setMaxValue(inputMaxValue_0);
      setMaxInputValue(inputMaxValue_0);
    };
    $[13] = max;
    $[14] = minInputValue;
    $[15] = onChange;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const handleCheckMaxValue = t6;
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = rangeValue => {
      if (Array.isArray(rangeValue)) {
        setMinValue(rangeValue[0]);
        setMinInputValue(rangeValue[0]);
        setMaxValue(rangeValue[1]);
        setMaxInputValue(rangeValue[1]);
      }
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const handleChange = t7;
  let t8;
  if ($[18] !== onChange) {
    t8 = rangeValue_0 => {
      if (Array.isArray(rangeValue_0)) {
        onChange(String(rangeValue_0[0]), String(rangeValue_0[1]));
      }
    };
    $[18] = onChange;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const handleChangeEnd = t8;
  const t9 = String(min);
  const t10 = isMinValueNull ? "" : minInputValue;
  let t11;
  if ($[20] !== ariaLabelMin || $[21] !== disabled || $[22] !== handleLowerBoundValue || $[23] !== t10 || $[24] !== t9) {
    t11 = <input disabled={disabled} className={styles.range_controlsInput} aria-label={ariaLabelMin} id="range-min" type="number" placeholder={t9} value={t10} onChange={handleLowerBoundChange} onBlur={handleLowerBoundValue} />;
    $[20] = ariaLabelMin;
    $[21] = disabled;
    $[22] = handleLowerBoundValue;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={styles.range_controlsDivider} />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = String(max);
  const t14 = isMaxValueNull ? "" : maxInputValue;
  let t15;
  if ($[27] !== ariaLabelMax || $[28] !== disabled || $[29] !== handleCheckMaxValue || $[30] !== t13 || $[31] !== t14) {
    t15 = <input disabled={disabled} className={styles.range_controlsInput} aria-label={ariaLabelMax} id="range-max" type="number" placeholder={t13} value={t14} onChange={handleUpperBoundChange} onBlur={handleCheckMaxValue} />;
    $[27] = ariaLabelMax;
    $[28] = disabled;
    $[29] = handleCheckMaxValue;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t11 || $[34] !== t15) {
    t16 = <div className={styles.range_controls}>{t11}{t12}{t15}</div>;
    $[33] = t11;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const t17 = direction === "rtl";
  const t18 = Number(minValue);
  const t19 = Number(maxValue);
  let t20;
  if ($[36] !== t18 || $[37] !== t19) {
    t20 = [t18, t19];
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== disabled || $[40] !== handleChangeEnd || $[41] !== max || $[42] !== min || $[43] !== step || $[44] !== t17 || $[45] !== t20) {
    t21 = <div className={styles.range_input}><Slider disabled={disabled} reverse={t17} range={true} step={step} min={min} max={max} value={t20} allowCross={false} onChangeComplete={handleChangeEnd} onChange={handleChange} /></div>;
    $[39] = disabled;
    $[40] = handleChangeEnd;
    $[41] = max;
    $[42] = min;
    $[43] = step;
    $[44] = t17;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t16 || $[48] !== t21) {
    t22 = <div className={styles.range}>{t16}{t21}</div>;
    $[47] = t16;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  return t22;
}